// extracted by mini-css-extract-plugin
export default {"content":"JournalPage_content__ZYgvr","info":"JournalPage_info__5W34S","btn_wrapper":"JournalPage_btn_wrapper__n973S","container":"JournalPage_container__SZPoW"};